import { z } from "zod";
/** Who is selling: a MyManager employee, or a Partner from the partner program. */
export const AgentKind = z.enum(["internal", "partner"]);
/** Studio-owned role. MyManager proves identity; the studio decides what it means here. */
export const AgentRole = z.enum(["agent", "manager", "superadmin"]);
export const AgentStatus = z.enum(["active", "disabled"]);
/** Pipeline stage. Order matters — it is the funnel. */
export const ProspectStage = z.enum([
    "new",
    "demo_built",
    "demo_shared",
    "engaged",
    "proposal",
    "closing",
]);
/**
 * Outcome is separate from stage so a prospect keeps its funnel position when
 * it closes. `missed` = went stale and was never worked; `lost` = worked and lost.
 */
export const ProspectOutcome = z.enum(["open", "won", "lost", "missed"]);
export const ProspectSource = z.enum([
    "manual",
    "google_places",
    "website",
    "menu_pdf",
    "ubereats",
    "doordash",
    "grubhub",
    "mymanager",
    "onboarding_lead",
    "partner_referral",
]);
export const DemoStatus = z.enum(["provisioning", "active", "expired", "revoked", "failed"]);
/** The apps a demo can expose in the portal. */
export const DemoApp = z.enum(["admin", "client", "pos", "website"]);
export const ImportPlatform = z.enum([
    "google_places",
    "website",
    "menu_pdf",
    "ubereats",
    "doordash",
    "grubhub",
    "mymanager",
]);
export const ImportStatus = z.enum(["queued", "running", "review", "applied", "failed"]);
/**
 * Activity is append-only. Every metric (win rate, time-to-close, missed
 * follow-ups) is an aggregation over these, so new metrics are retroactive.
 */
export const ActivityType = z.enum([
    "prospect_created",
    "call_logged",
    "note_added",
    "demo_created",
    "demo_launched",
    "demo_extended",
    "demo_revoked",
    "demo_expired",
    "demo_removed",
    "link_shared",
    "link_opened",
    "portal_section_viewed",
    "portal_info_saved",
    "import_started",
    "import_applied",
    "stage_changed",
    "assigned",
    "sla_warning",
    "sla_reassigned",
    "won",
    "lost",
    "missed",
]);
export const AssignmentReason = z.enum([
    "initial",
    "manual",
    "sla_expired",
    "partner_request",
    "extension",
]);
/** pos = SUNMI POS, admin = owner app, client = MyManager Connect, whitelabel = Connect reskinned as their own app. */
export const EmulatorApp = z.enum(["pos", "admin", "client", "whitelabel"]);
export const SessionStatus = z.enum(["starting", "ready", "ended", "failed"]);
//# sourceMappingURL=enums.js.map